import type { TkDict } from "./types";

const dict: TkDict = {
  uz: {
    "tk.checkout.secure": "Xavfsiz to'lov",
    "tk.checkout.steps": "Bosqichlar",
    "tk.checkout.step.details": "Ma'lumotlar",
    "tk.checkout.method.payme": "Payme ilovasi yoki karta orqali",
    "tk.checkout.method.click": "Click ilovasi yoki karta orqali",
    "tk.checkout.method.card": "Bank kartasi",
    "tk.checkout.method.lemon": "Lemon Squeezy orqali",
    "tk.checkout.redirect_note": "«To'lash» tugmasini bosgach, {provider} sahifasida to'lovni tasdiqlaysiz va shu yerga qaytasiz.",
    "tk.checkout.row.plan": "Tarif",
    "tk.checkout.help": "Savol bo'lsa,",
    "tk.checkout.help_link": "Telegram orqali yozing",
    "tk.checkout.months": "yanvar,fevral,mart,aprel,may,iyun,iyul,avgust,sentabr,oktabr,noyabr,dekabr",
    "tk.checkout.date": "{d}-{m}, {y}",
  },
  ru: {
    "tk.checkout.secure": "Безопасная оплата",
    "tk.checkout.steps": "Этапы",
    "tk.checkout.step.details": "Данные",
    "tk.checkout.method.payme": "Через приложение Payme или картой",
    "tk.checkout.method.click": "Через приложение Click или картой",
    "tk.checkout.method.card": "Банковская карта",
    "tk.checkout.method.lemon": "Через Lemon Squeezy",
    "tk.checkout.redirect_note": "После нажатия «Оплатить» вы подтвердите платёж на странице {provider} и вернётесь сюда.",
    "tk.checkout.row.plan": "Тариф",
    "tk.checkout.help": "Есть вопросы?",
    "tk.checkout.help_link": "Напишите нам в Telegram",
    "tk.checkout.months": "января,февраля,марта,апреля,мая,июня,июля,августа,сентября,октября,ноября,декабря",
    "tk.checkout.date": "{d} {m} {y}",
  },
  en: {
    "tk.checkout.secure": "Secure payment",
    "tk.checkout.steps": "Steps",
    "tk.checkout.step.details": "Details",
    "tk.checkout.method.payme": "Payme app or card",
    "tk.checkout.method.click": "Click app or card",
    "tk.checkout.method.card": "Bank card",
    "tk.checkout.method.lemon": "Via Lemon Squeezy",
    "tk.checkout.redirect_note": "After you tap “Pay”, you'll confirm the payment on the {provider} page and come back here.",
    "tk.checkout.row.plan": "Plan",
    "tk.checkout.help": "Questions?",
    "tk.checkout.help_link": "Message us on Telegram",
    "tk.checkout.months": "January,February,March,April,May,June,July,August,September,October,November,December",
    "tk.checkout.date": "{m} {d}, {y}",
  },
};

export default dict;
